export default __webpack_public_path__ + "static/media/14.4b9e26fa.webp";